import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/outline";
import AgencyAction from "../../components/action/AgencyAction";
import DowloadDocument from "../../components/action/DownloadDocument";

export const HeaderDocuments = (listCategories: any) => ([
    {
        Header: "Nome documento",
        accessor: "nome",
        disableSortBy: true,
        Filter: false,
        customSort: false,
        Cell: ({ row }: any) => (
            <DowloadDocument documento={row.original} label={row.original.nome} />
        )
    },
    {
        Header: "",
        accessor: "action",
        disableSortBy: true,
        Filter: false,
        customSort: false,
        Cell: ({ row }: any) => (
            <div className="flex space-x-4 justify-end items-center px-5">
                <AgencyAction type="updateDocument" icon={<PencilSquareIcon className="w-6 h-6" />} idAzienda={row.original.aziendaId} infoForm={row.original} listCategories={listCategories} />
                <AgencyAction type="deleteDocument" icon={<TrashIcon className="w-5 h-5" />} idAzienda={row.original.aziendaId} infoForm={row.original} />
            </div>
        )
    }
])